.choice {
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  gap: var(--space-2);
  min-height: 24px;
  color: var(--color-text-primary);
  font-size: var(--type-body-size);
  line-height: var(--type-body-line);
  cursor: pointer;
}

.choice[data-disabled='true'] {
  color: var(--color-text-disabled);
  cursor: not-allowed;
}

.input {
  position: absolute;
  top: 0;
  left: 0;
  width: 24px;
  height: 24px;
  margin: 0;
  opacity: 0;
  cursor: inherit;
}

.box {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin: 3px;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-sm);
  background: var(--color-field);
  color: var(--color-text-on-color);
  transition:
    background-color var(--duration-fast-01) var(--ease-standard),
    border-color var(--duration-fast-01) var(--ease-standard);
}

.box {
  position: relative;
}

.box svg {
  position: absolute;
  inset: 0;
  margin: auto;
  fill: currentColor;
  visibility: hidden;
}

.input:checked + .box,
.input:indeterminate + .box {
  border-color: var(--color-interactive);
  background: var(--color-interactive);
}

.input:checked + .box svg.check,
.input:indeterminate + .box svg.dash {
  visibility: visible;
}

.input:indeterminate + .box svg.check {
  visibility: hidden;
}

.input:focus-visible + .box,
.input:focus-visible + .circle {
  outline: 2px solid var(--color-focus);
  outline-offset: 1px;
}

.input:disabled + .box,
.input:disabled + .circle {
  border-color: var(--color-border-subtle);
  background: var(--color-field-disabled);
}

.input:disabled:checked + .box {
  background: var(--color-border-subtle);
}

.choice[data-invalid='true'] .box,
.choice[data-invalid='true'] .circle {
  border-color: var(--color-error);
}

.circle {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: 2px;
  border: 1px solid var(--color-border-strong);
  border-radius: 50%;
  background: var(--color-field);
}

.circle::after {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--color-interactive);
  transform: scale(0);
  transition: transform var(--duration-fast-02) var(--ease-standard);
}

.input:checked + .circle {
  border-color: var(--color-interactive);
}

.input:checked + .circle::after {
  transform: scale(1);
}

.input:disabled:checked + .circle::after {
  background: var(--color-text-disabled);
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.description {
  color: var(--color-text-helper);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.horizontal {
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--space-3) var(--space-6);
}

.switchRow {
  display: inline-flex;
  align-items: center;
  gap: var(--space-3);
}

.switch {
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-pill);
  background: var(--color-toggle-off);
  transition: background-color var(--duration-fast-02) var(--ease-standard);
}

.switch::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--color-switch-knob);
  transition: transform var(--duration-fast-02) var(--ease-standard);
}

.switch[aria-checked='true'] {
  background: var(--color-interactive);
}

.switch[aria-checked='true']::after {
  transform: translateX(20px);
}

.switch:disabled {
  background: var(--color-layer-2);
}

.switch:disabled::after {
  background: var(--color-field-disabled);
}

.switchLabel {
  color: var(--color-text-primary);
  font-size: var(--type-body-size);
  line-height: var(--type-body-line);
  cursor: pointer;
}

.switchState {
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  min-width: 3ch;
}

.switchText {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.switchDisabled .switchLabel {
  color: var(--color-text-disabled);
  cursor: not-allowed;
}

@media (forced-colors: active) {
  .box,
  .circle,
  .switch {
    border: 1px solid CanvasText;
  }
}
